import { Injectable } from '@angular/core';

import { motoristasRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import {recursosHumanosRoute} from "../../shared/data.service";

@Injectable()
export class MotoristaNavigationService {
  moduleRouter: string = motoristasRoute;
  fatherRouter: string = recursosHumanosRoute;

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/shared/motorista-navigation.service.ts
 **/